import Vue from "vue";
// import Bulma from 'bulma'
import Buefy from "buefy";

Vue.use(Buefy),
  { defaultIconComponent: "vue-fontawesome", defaultIconPack: "fas" };
// Vue.use(Buefy);